import React, { useContext, useEffect, useState } from 'react'
import WideCard from '../components/WideCard.tsx/WideCard'
import { Row, Col } from 'react-bootstrap'
import ChartContent from '../components/Chart/ChartContent'
import { STable, SDashboard } from './sharedSectionStyles'
import { dateFormatter, nFormatter } from '../utils/numbers'
import { ITHORCHAINDashboard } from '../api/interfaces'
import { IChartConfig } from '../components/Chart/interface'
import LoadingChart from '../components/LoadingIcon/Loading'
import { ThemeContext } from '../App'
import { getTotalValueLockedConfig } from './networkSection/TVLocked'
import { getSwapVolumeConfig } from './swapsSection/SwapVolume'
import { getSwapCountConfig } from './swapsSection/SwapCount'
import { getLPDepthDistributionConfig } from './liquidityPoolsSection/LPDepthDistribution'
import { getEarningsBreakdownConfig } from './networkSection/EarningsBreakdown'

const FeaturedDashboard = () => {
	const { setTheme, theme } = useContext(ThemeContext)
	const [dataSeries1, setDataSeries1] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries2, setDataSeries2] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries4, setDataSeries4] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries7, setDataSeries7] = useState<IChartConfig | undefined>(undefined)
	const [dataSeries8, setDataSeries8] = useState<IChartConfig | undefined>(undefined)

	const InitializeData = async (color: string, inverseColor: string) => {
		try {
			setDataSeries2(await getLPDepthDistributionConfig(color, inverseColor, '1m'))
			setDataSeries4(await getTotalValueLockedConfig(color, inverseColor, '1w'))
			setDataSeries7(await getSwapCountConfig(color, inverseColor, '1m'))
			setDataSeries8(await getSwapVolumeConfig(color, inverseColor, '1m'))
			setDataSeries1(await getEarningsBreakdownConfig(color, inverseColor, '1d'))
		} catch (error) {
			console.log(error)
		}
	}
	useEffect(() => {
		let mainColor = theme === 'dark' ? 'white' : 'black'
		let inverseMainColor = theme === 'dark' ? 'black' : 'white'
		InitializeData(mainColor, inverseMainColor)
	}, [theme])
	if (dataSeries2 !== undefined && dataSeries4 !== undefined && dataSeries7 !== undefined && dataSeries8 !== undefined && dataSeries1 !== undefined) {
		return (
			<SDashboard>
				<Row>
					<Col>
						<WideCard
							cardTitle="Total Swap Volume"
							cardValue={`${nFormatter(dataSeries8.latestValue)} USD`}
							cardValueDate={`${dateFormatter(dataSeries8.latestValueDate)}`}
							link="/thorchain_swap_volume"
						/>
						<ChartContent
							dataSeries={dataSeries8.config}
							chartHeight="35vh"
							chartWidth="100%"
							chartTitle="Swap Volume"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 36}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<ChartContent
							dataSeries={dataSeries1.config}
							chartHeight="45vh"
							chartWidth="100%"
							chartTitle="Earnings and Distribution Breakdown"
							isMinimalChart={true}
							hasLogScale={false}
							reverseLegend={true}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 2}
						/>
					</Col>
				</Row>
				<br />
				<Row>
					<Col>
						<WideCard
							cardTitle="Liquidity in Pools"
							cardValue={`${nFormatter(dataSeries2.latestValue)} USD`}
							cardValueDate={`${dateFormatter(dataSeries2.latestValueDate)}`}
							link="/thorchain_lp_liquidity_distribution"
						/>
						<ChartContent
							dataSeries={dataSeries2.config}
							chartHeight="35vh"
							chartWidth="50%"
							chartTitle="Liquidity Distribution"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 24}
						/>
					</Col>
					<Col>
						<WideCard cardTitle="Total Swap Count" cardValue={`${nFormatter(dataSeries7.latestValue)}`} cardValueDate={`${dateFormatter(dataSeries7.latestValueDate)}`} link="/thorchain_swap_count" />
						<ChartContent
							dataSeries={dataSeries7.config}
							chartHeight="35vh"
							chartWidth="50%"
							chartTitle="Swap Count"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 36}
						/>
					</Col>
				</Row>
				<br />
				<Row>
					<Col>
						<WideCard
							cardTitle="Total Value Locked"
							cardValue={`${nFormatter(dataSeries4.latestValue)} USD`}
							cardValueDate={`${dateFormatter(dataSeries4.latestValueDate)}`}
							link="/thorchain_tv_locked"
						/>
						<ChartContent
							dataSeries={dataSeries4.config}
							chartHeight="35vh"
							chartWidth="50%"
							chartTitle="Total Value Locked"
							isMinimalChart={true}
							hasLogScale={false}
							startZoom={Date.now() / 1000 - 3600 * 24 * 30 * 36}
						/>
					</Col>
				</Row>
			</SDashboard>
		)
	} else {
		return <LoadingChart />
	}
}

export default FeaturedDashboard
